<div class="request-table-container">
  <table
    mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    [trackBy]="trackByRequestId"
    matSort
    (matSortChange)="onSortChanged($event)"
    class="mat-elevation-z1 full-width plain-table row__content--button-header-aligned">
    <!-- Expand toggle -->
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button type="button" (click)="toggleRow(row); $event.stopPropagation()" [disabled]="!row.subRequestCount">
          <mat-icon>{{ row.id === expandedElementId ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('id'), integerOnly: true }">
          {{ 'dataManagement.dataExchangeRequests.columns.id' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.id }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('name') }">
          {{ 'dataManagement.dataExchangeRequests.columns.name' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('name'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button" (click)="$event.stopPropagation()">
          {{ 'dataManagement.dataExchangeRequests.columns.createdAt' | transloco }}
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ getDate(row.createdAt) | date: 'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('status'), categories: getStatusOptions() }">
          {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
          <mat-icon class="filter-icon" *ngIf="isStatusFilterCustomized()">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="status-cell">
          <span>{{ getStatusLabel(row.status) | transloco }}</span>
          @if (row.reopenBadgeType; as badgeType) {
            @if (isReceived) {
              <app-badge [type]="badgeType" [translationKey]="row.reopenBadgeLabel"></app-badge>
            } @else {
              <button class="badge-button" type="button" (click)="onOpenReopenDecisions(row); $event.stopPropagation()">
                <app-badge [type]="badgeType" [translationKey]="row.reopenBadgeLabel"></app-badge>
              </button>
            }
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="deadline">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button" (click)="$event.stopPropagation()">
          {{ 'dataManagement.dataExchangeRequests.columns.deadline' | transloco }}
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <button
          *ngIf="row.canEditDeadline; else deadlineReadonly"
          mat-button
          class="deadline-link"
          [class.deadline-link--empty]="!row.deadline"
          type="button"
          [title]="'dataManagement.dataExchangeRequests.actions.editDeadline' | transloco"
          (click)="onEditDeadline(row); $event.stopPropagation()">
          {{ row.deadline ? (row.deadline | date: 'shortDate') : ('dataManagement.dataExchangeRequests.actions.setDeadline' | transloco) }}
          <mat-icon class="deadline-link__icon">calendar_today</mat-icon>
        </button>
        <ng-template #deadlineReadonly>{{ row.deadline ? (row.deadline | date: 'shortDate') : '- - - - -' }}</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="deadlineState">
      <th mat-header-cell *matHeaderCellDef>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('deadlineState'), categories: getDeadlineStateOptions() }"
          [title]="'dataManagement.dataExchangeRequests.columns.deadlineState' | transloco">
          <mat-icon>flag</mat-icon>
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('deadlineState'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <app-badge *ngIf="row.deadlineBadgeType as badgeType" [type]="badgeType" [translationKey]="row.deadlineStateLabel"></app-badge>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="!isReceived">
          <button
            mat-icon-button
            type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.withdraw' | transloco"
            [disabled]="row.status === requestStatus.Deleted"
            (click)="onWithdrawRequest(row); $event.stopPropagation()">
            <mat-icon>undo</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.approve' | transloco"
            [disabled]="!row.canApprove"
            (click)="onApproveRequest(row); $event.stopPropagation()">
            <mat-icon>done_all</mat-icon>
          </button>
        </ng-container>
        @if (isReceived) {
          <button
            mat-icon-button
            type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.reopen' | transloco"
            [disabled]="!row.canReopen"
            (click)="onReopenRequest(row); $event.stopPropagation()">
            <mat-icon>replay</mat-icon>
          </button>
        }
        @if (isReceived && row.status !== requestStatus.Deleted) {
          <button mat-icon-button type="button" [title]="'dataManagement.dataExchangeRequests.actions.saveToDirectory' | transloco" (click)="saveToDirectory(row, $event)">
            <mat-icon>save_alt</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="counterpart">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('counterpart') }">
          {{ (isReceived ? 'dataManagement.dataExchangeRequests.columns.sender' : 'dataManagement.dataExchangeRequests.columns.recipient') | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('counterpart'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ isReceived ? row.sendingSecurityPrincipal?.name : row.receivingSecurityPrincipal?.name }}</td>
    </ng-container>

    <ng-container matColumnDef="subRequestCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('subRequestCount') }">
          {{ 'dataManagement.dataExchangeRequests.columns.items' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('subRequestCount'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.subRequestCount ?? 0 }}</td>
    </ng-container>

    <!-- Expandable detail row -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
        <div class="detail-container" [@detailExpand]="row.id === expandedElementId ? 'expanded' : 'collapsed'">
          <ng-container *ngIf="row.id === expandedElementId">
            <app-data-exchange-sub-request-table
              [dataSource]="getSubRequestDataSource(row)"
              [dataExchangeRequestId]="row.id"
              [isReceived]="isReceived"
              (navigateToSubRequest)="onNavigateSubRequest($event)"
              (approveSubRequest)="onApproveSubRequest($event)"
              (reopenSubRequest)="onReopenSubRequest($event)"
              (withdrawSubRequest)="onWithdrawSubRequest($event)"
              (showSubRequestComments)="onShowSubRequestComments($event)"
              (openLocalCopy)="onOpenLocalCopy($event)">
            </app-data-exchange-sub-request-table>
          </ng-container>

          <!-- Deadline status badges -->
          @if (row.deadline) {
            <div class="deadline-status-section">
              @if (row.submission.deadlineBadgeType; as badgeType) {
                <app-badge [type]="badgeType" [translationKey]="row.submission.deadlineStateLabel"></app-badge>
              }
              @if (row.closing.deadlineBadgeType; as badgeType) {
                <app-badge [type]="badgeType" [translationKey]="row.closing.deadlineStateLabel"></app-badge>
              }
            </div>
          }

          <!-- Comments -->
          <div class="comments-section">
            <h4 class="comments-title">{{ 'dataManagement.dataExchangeRequests.comments.title' | transloco }}</h4>
            <app-data-exchange-comments [comments]="row.comments" (commentAdded)="onCommentAdded($event, row)"> </app-data-exchange-comments>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="request-row"
      [class.expanded-row]="row.id === expandedElementId"
      [class.notificationBackground]="row.unseenNotificationCount > 0"
      (click)="toggleRow(row)"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        {{ 'dataManagement.dataExchangeRequests.noData' | transloco }}
      </td>
    </tr>
  </table>

  <div class="loading-overlay" *ngIf="isLoading | async">
    <mat-spinner diameter="48" color="accent"></mat-spinner>
  </div>

  <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
</div>

<mat-paginator class="request-paginator" [length]="1" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page" (page)="onPageChanged($event)"></mat-paginator>
